import { render, staticRenderFns } from "./task-summary.vue?vue&type=template&id=cba57e10&scoped=true"
import script from "./task-summary.vue?vue&type=script&lang=js"
export * from "./task-summary.vue?vue&type=script&lang=js"
import style0 from "./task-summary.vue?vue&type=style&index=0&id=cba57e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba57e10",
  null
  
)

export default component.exports